import { NAME } from 'domain/operations/accountManagement/constants';

export const APPROVE_DRIVER = `${NAME}/APPROVE_DRIVER`;
export const DECLINE_DRIVER = `${NAME}/DECLINE_DRIVER`;
export const APPROVE_SHIPPER = `${NAME}/APPROVE_SHIPPER`;
export const DECLINE_SHIPPER = `${NAME}/DECLINE_SHIPPER`;
export const MAKE_OPERATOR = `${NAME}/MAKE_OPERATOR`;
export const REVOKE_OPERATOR = `${NAME}/REVOKE_OPERATOR`;
export const MAKE_ACCOUNT_ADMIN = `${NAME}/MAKE_ACCOUNT_ADMIN`;
export const REVOKE_ACCOUNT_ADMIN = `${NAME}/REVOKE_ACCOUNT_ADMIN`;
export const MAKE_FINANCE_ADMIN = `${NAME}/MAKE_FINANCE_ADMIN`;
export const REVOKE_FINANCE_ADMIN = `${NAME}/REVOKE_FINANCE_ADMIN`;
export const MAKE_FLEET_ADMIN = `${NAME}/MAKE_FLEET_ADMIN`;

export const REFRESH_DRIVERS = `${NAME}/REFRESH_DRIVERS`;
export const REFRESH_SHIPPERS = `${NAME}/REFRESH_SHIPPERS`;
export const REFRESH_SHIPMENTS = `${NAME}/REFRESH_SHIPMENTS`;

export const MAKE_PROFILE = `${NAME}/MAKE_PROFILE`;
export const MAKE_PROFILE_DONE = `${NAME}/MAKE_PROFILE_DONE`;

export const ACTIVATE_PROFILE = `${NAME}/ACTIVATE_PROFILE`;
export const ACTIVATE_PROFILE_DONE = `${NAME}/ACTIVATE_PROFILE_DONE`;

export const REVOKE_PROFILE = `${NAME}/REVOKE_PROFILE`;
export const REVOKE_PROFILE_DONE = `${NAME}/REVOKE_PROFILE_DONE`;
export const PROFILE_ACTIVATED = `${NAME}/PROFILE_ACTIVATED`;
export const PROFILE_SUSPENDED = `${NAME}/PROFILE_SUSPENDED`;
export const DRIVER_MADE_AVAILABLE = `${NAME}/DRIVER_MADE_AVAILABLE`;
export const DRIVER_MADE_UNAVAILABLE = `${NAME}/DRIVER_MADE_UNAVAILABLE`;
